/* eslint-disable @typescript-eslint/no-explicit-any */
// Adiciona prefixo /api se não estiver presente na URL
const processApiUrl = (url: string): string => {
  if (!url) return '';

  // Se a URL já termina com /api, não adiciona novamente
  if (url.endsWith('/api')) return url;

  // Se a URL já contém /api/, não adiciona
  if (url.includes('/api/')) return url;

  // Adiciona /api no final da URL, garantindo que não duplicamos barras
  return url.endsWith('/') ? `${url}api` : `${url}/api`;
};

// Deriva a base das rotas montadas na raiz da api (sem prefixo /api) a partir da
// URL canônica do backend (VITE_PRODGY_API_URL). A api é host único: serve tanto
// /api/* (compat) quanto as rotas na raiz, então as duas saem da mesma base.
const deriveRootBase = (url: string): string =>
  (url || '').replace(/\/+$/, '').replace(/\/api$/, '');

// O Vite substitui `import.meta.env.VITE_X` ESTATICAMENTE, no texto do módulo.
// Acesso dinâmico — `(import.meta as any)?.env?.VITE_X` — não casa com esse
// padrão, então nada era substituído e no browser `import.meta.env` não existe:
// a leitura resultava em undefined e caía SEMPRE no fallback fixo abaixo.
// Passava despercebido porque o fallback coincide com a porta padrão da api; só
// aparece quando ela roda em outra porta (ex.: git worktree isolada), e aí o
// front chama a cópia errada do backend.
const viteApiUrl = import.meta.env.VITE_PRODGY_API_URL as string | undefined;

// Obter URL base da API
const rawApiUrl = (typeof window !== 'undefined' && window.ENV?.VITE_PRODGY_API_URL && window.ENV.VITE_PRODGY_API_URL !== '')
  ? window.ENV.VITE_PRODGY_API_URL
  : (viteApiUrl ||
    ((typeof process !== 'undefined' ? (process as any) : undefined)?.env?.VITE_PRODGY_API_URL as string | undefined) ||
    'http://localhost:4000');

const apiUrl = processApiUrl(rawApiUrl || '');

// Obter Webhook URL
const webhookUrl = (typeof window !== 'undefined' && window.ENV?.VITE_PRODGY_WEBHOOK_URL && window.ENV.VITE_PRODGY_WEBHOOK_URL !== '')
  ? window.ENV.VITE_PRODGY_WEBHOOK_URL
  : ((import.meta.env.VITE_PRODGY_WEBHOOK_URL as string | undefined) ||
    ((typeof process !== 'undefined' ? (process as any) : undefined)?.env?.VITE_PRODGY_WEBHOOK_URL as string | undefined));

// Base das rotas na raiz da api (sem prefixo /api) — derivada de VITE_PRODGY_API_URL.
const rootBaseUrl = deriveRootBase(rawApiUrl);

export const API_CONFIG = {
  API_URL: apiUrl,
  API_ROOT_URL: rootBaseUrl,
  apiUrl: apiUrl,
  WEBHOOK_URL: webhookUrl
};

// Importar configuração de domínio para webhook proxy
export { DOMAIN_CONFIG } from './domain';
